import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "content" }

import InsuranceExportBlank from "@/shared/model/InsuranceExportBlank";
import {computed} from 'vue'
import {useNavigationStore} from "@/modules/Navigation/store";
import {IdType} from "@/shared/model/idType";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";
import SogButton from "@/shared/ui/SogButton.vue";

interface Props {
  insuranceExportBlank?: InsuranceExportBlank,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InsuranceExportBlankDetailsComponent',
  props: {
    insuranceExportBlank: { default: undefined }
  },
  setup(__props: any) {


const _navigationStore = useNavigationStore()

const props = __props

const _insuranceNumberInfoVisibile = computed(() => {
  return props.insuranceExportBlank?.insuranceId != null
})

const _kennzeichenInfoVisible = computed(() => {
  return props.insuranceExportBlank?.kennzeichen != null
})

function _onInsuranceInfoClicked() {
  _navigationStore.currentInsuranceId = props.insuranceExportBlank?.insuranceId
  _navigationStore.currentInsuranceNumber = props.insuranceExportBlank?.insuranceNumber
}

function _onKennzeichenInfoClicked() {
  _navigationStore.currentVehicleRegistrationId = props.insuranceExportBlank?.vehicleRegistrationId
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tr", null, [
      _cache[0] || (_cache[0] = _createElementVNode("td", null, "Versicherungsscheinnummer", -1)),
      _createElementVNode("td", null, [
        _createTextVNode(_toDisplayString(__props.insuranceExportBlank?.insuranceNumber) + " ", 1),
        _withDirectives(_createVNode(SogButton, {
          class: "info-button",
          "mdi-icon": "mdi-shield",
          "button-style": _unref(SogButtonStyle).Link,
          onClick: _onInsuranceInfoClicked
        }, null, 8, ["button-style"]), [
          [_vShow, _insuranceNumberInfoVisibile.value]
        ])
      ])
    ]),
    _createElementVNode("tr", null, [
      _cache[1] || (_cache[1] = _createElementVNode("td", null, "Versicherer", -1)),
      _createElementVNode("td", null, _toDisplayString(__props.insuranceExportBlank?.manufacturerName), 1)
    ]),
    _createElementVNode("tr", null, [
      _cache[2] || (_cache[2] = _createElementVNode("td", null, "Kennzeichen", -1)),
      _createElementVNode("td", null, [
        _createTextVNode(_toDisplayString(__props.insuranceExportBlank?.kennzeichen) + " ", 1),
        _withDirectives(_createVNode(SogButton, {
          class: "info-button",
          "mdi-icon": "mdi-car",
          "button-style": _unref(SogButtonStyle).Link,
          onClick: _onKennzeichenInfoClicked
        }, null, 8, ["button-style"]), [
          [_vShow, _kennzeichenInfoVisible.value]
        ])
      ])
    ]),
    _createElementVNode("tr", null, [
      _cache[3] || (_cache[3] = _createElementVNode("td", null, "Drucktyp", -1)),
      _createElementVNode("td", null, _toDisplayString(__props.insuranceExportBlank?.printTypeDescription), 1)
    ]),
    _createElementVNode("tr", null, [
      _cache[4] || (_cache[4] = _createElementVNode("td", null, "Gültigkeitsjahr", -1)),
      _createElementVNode("td", null, _toDisplayString(__props.insuranceExportBlank?.printYearDescription), 1)
    ]),
    _createElementVNode("tr", null, [
      _cache[5] || (_cache[5] = _createElementVNode("td", null, "Status", -1)),
      _createElementVNode("td", null, _toDisplayString(__props.insuranceExportBlank?.statusDescription), 1)
    ])
  ]))
}
}

})